//https://api.hqz.app/
//https://dev-api.hqz.app/
export const baseURL = "https://dev-api.hqz.app/";
export const secretKey = "aw6xayDawf3cUm22QtMHlxfL8lZESl0W";
export const projectName = "HQZ";
export const bucketName = "YOUR_BUCKET_NAME";
export const hostname = "YOUR_END_POINT";
export const aws_access_key_id = "AWS_ACCESS_KEY_ID";
export const aws_secret_access_key = "AWS_SECRET_ACCESS_KEY";
